import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import styled from '@emotion/styled'

const Wrapper = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  background-color: white;
  box-shadow: 0 1px 4px -1px rgba(40, 40, 40, 0.3);
  z-index: 2;
`

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1440px;
  height: 100px;
  margin: 0 auto;
  padding: 0;
  a {
    text-decoration: none;
    color: #333639;
  }
`

const Items = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0;
  list-style: none;
`

const Item = styled.div`
  align-self: center;
  display: inline-block;
  margin: 0 1rem 0 0;
  &:last-child {
    margin-right: 0;
  }
  & a {
    color: ${props => props.isSelected ? '#E6823B' : 'inherit'};
    transition: color 0.5s ease;

    &:hover {
      color: #E0640D;
    }
  }
`

const List = Items.withComponent('ul')
const ListItem = Item.withComponent('li')

const ListLink = props => (
  <ListItem isSelected={props.isSelected}>
    <Link to={props.to}>{props.children}</Link>
  </ListItem>
)

function Header({ title, slug, pages }) {
  const data = useStaticQuery(graphql`
    query HeaderQuery {
      logo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fixed(height: 60) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return (
    <Wrapper id="masthead">
      <Container>
        <Items>
          <Item>
            <Link to="/">
              <Img fixed={data.logo.childImageSharp.fixed} alt={title} />
            </Link>
          </Item>
        </Items>
        <List>
          {pages.map(page => (
            <ListLink
              key={page.contentful_id}
              to={page.slug}
              isSelected={page.slug === slug}
            >
              {page.title}
            </ListLink>
          ))}
        </List>
      </Container>
    </Wrapper>
  )
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  pages: PropTypes.array.isRequired,
}

export default Header
